module.exports = __webpack_public_path__ + "img/guzhang.1dea4133.png";